import Add from './add';
import History from './history';
import Transform from './transform';
import Remove from './remove';

function mount(): void {
    // 新增
    Add.mountApi();

    // 历史记录
    History.mountApi();

    // 画布矩阵变化
    Transform.mountApi();

    // 删除
    Remove.mountApi();
}

export default {
    mount
};
